import { render, staticRenderFns } from "./AttendanceHistory.vue?vue&type=template&id=2752e277"
import script from "./AttendanceHistory.vue?vue&type=script&lang=js"
export * from "./AttendanceHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports